<template>
  <div class="divWrap">
  </div>
</template>

<script>
import constantName from '@/utils/constant'
export default {
  name: 'ssoGetCode',
  data () {
    return {
      loginForm: {
        code: '',
        sPassword: '',
        sLoginType: 'WEB'
      }
    }
  },
  created () {
  },
  mounted: function () {
    window.open(constantName.auth_uri, '_self')
  },
  methods: {
  }
}
</script>

<style scoped>
  .divWrap{
    position: absolute;
    width: 100%;
    height: 100%;
    background-size: 100% 100% !important;
    background: linear-gradient(#7db4ff, #2c77ea);
    /*background-img: url();*/
  }
</style>



// WEBPACK FOOTER //
// src/views/common/ssoGetCode.vue